const config = require('../../../../../config/locales_json/packs/private/validations/register.json');
const language = $('body').data("language");

$("#kt_login_signup_form #kt_login_signup_submit").on("click", function(e){
  e.preventDefault()

  var error = 0
  var email = $("#kt_login_signup_form #user_email")
  var password = $("#kt_login_signup_form #user_password")
  var rePassword = $("#kt_login_signup_form #user_password_confirmation")
  var terms = $("#kt_login_signup_form #user_terms")

  const emailRegex = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;
  const emailVal = email.val().trim();
  const isValidEmail = emailVal ? emailRegex.test(emailVal) : false;
  
  if(!isValidEmail){
    const errorText = getTranslationValue(config, [language, "email_error"],"Debes ingresar un email");
    email.removeClass("is-invalid").addClass("is-invalid")
    email.parent().find(".invalid-feedback").remove()
    email.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    email.parent().find(".invalid-feedback").remove()
    email.removeClass("is-invalid")
  }

  if(!password.val()){
    const errorText = getTranslationValue(config, [language, "empty_password"],"Debes ingresar una contraseña");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
    adjustPasswordIconPosition();
  } else if(password.val().length < 6){
    const errorText = getTranslationValue(config, [language, "short_password"],"Debes ingresar la cantidad de caracteres indicados");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++;
    adjustPasswordIconPosition();
  }
  // Validación adicional: debe tener al menos una mayúscula
  if (!/[A-Z]/.test(password.val())) {
    const errorText = getTranslationValue(config, [language, "password_uppercase_missing"], "La contraseña debe contener al menos una letra mayúscula.");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">' + errorText + '</div>')
    error++
    adjustPasswordIconPosition();
  }

  // Validación adicional: debe tener al menos un número
  if (!/[0-9]/.test(password.val())) {
    const errorText = getTranslationValue(config, [language, "password_number_missing"], "La contraseña debe contener al menos un número.");
    password.removeClass("is-invalid").addClass("is-invalid")
    password.parent().find(".invalid-feedback").remove()
    password.parent().find(".help-block").before('<div class="invalid-feedback js-error">' + errorText + '</div>')
    error++
    adjustPasswordIconPosition();
  }


  if(!rePassword.val()){
    const errorText = getTranslationValue(config, [language, "empty_re_password"],"Debes ingresar nuevamente tu contraseña");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else if(password.val() != rePassword.val()) {
    const errorText = getTranslationValue(config, [language, "password_not_match"],"Las contraseñas no son iguales");
    rePassword.removeClass("is-invalid").addClass("is-invalid")
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    rePassword.parent().find(".invalid-feedback").remove()
    rePassword.removeClass("is-invalid")
    adjustPasswordIconPosition();
  }

  if(!terms.is(":checked")) {
    const errorText = getTranslationValue(config, [language, "check_terms_error"],"Debes aceptar los términos y condiciones");
    terms.parent().parent().find(".invalid-feedback").remove()
    terms.parent().parent().append('<div class="invalid-feedback js-error">'+errorText+'</div>')
    error++
  } else {
    //console.log("esta checkeado")
    terms.parent().parent().find(".invalid-feedback").remove()
  }
  //console.log(error)
  if(!error){
    const successText = getTranslationValue(config, [language, "not_error_text"],"Registrando...");
    $(this).addClass('send-button').val(successText)
    $("#kt_login_signup_form").submit()
  }
});


function adjustPasswordIconPosition() {
  const input = $("#user_password");
  const icon = $("#toggle-password");

  if (input.hasClass("is-invalid")) {
    icon.css("right", "41px");
    icon.css("top", "50%");
    icon.css("transform", "translateY(-100%)");
  } else {
    icon.css("right", "20px");
  }
}


function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}


const strengthContainer = $("#password-strength-container");
const strengthBar = $("#password-strength-bar");
const strengthText = $("#password-strength-text");

const requirements = $("#password-requirements");
const reqLength = $("#req-length");
const reqUppercase = $("#req-uppercase");
const reqNumber = $("#req-number");

$("#kt_login_signup_form #user_password").on("input", function() {
  const password = $(this).val();
  const strength = evaluatePasswordStrength(password);

  if (password.length === 0) {
    strengthContainer.hide();
    requirements.hide();
    return;
  }

  strengthContainer.show();
  requirements.show();

  // Requisitos mínimos
  const lengthMet = password.length >= 6;
  const uppercaseMet = /[A-Z]/.test(password);
  const numberMet = /[0-9]/.test(password);


  updateRequirement(
    reqLength,
    lengthMet,
    getTranslationValue(config, [language, "password_requirement_min_length"], "Mínimo 6 caracteres")
  );
  
  updateRequirement(
    reqUppercase,
    uppercaseMet,
    getTranslationValue(config, [language, "password_requirement_uppercase"], "Al menos una mayúscula")
  );
  
  updateRequirement(
    reqNumber,
    numberMet,
    getTranslationValue(config, [language, "password_requirement_number"], "Al menos un número")
  );
  

  // Barra de fuerza
  switch(strength.score) {
    case 0:
      strengthBar.css("width", "25%").css("background-color", "#dc3545");
      strengthText.text(getTranslationValue(config, [language, "password_strength_weak"], "Contraseña débil"));
      break;
    case 1:
      strengthBar.css("width", "50%").css("background-color", "#fd7e14");
      strengthText.text(getTranslationValue(config, [language, "password_strength_medium"], "Contraseña regular"));
      break;
    case 2:
      strengthBar.css("width", "75%").css("background-color", "#ffc107");
      strengthText.text(getTranslationValue(config, [language, "password_strength_ok"], "Contraseña aceptable"));
      break;
    case 3:
      strengthBar.css("width", "100%").css("background-color", "#28a745");
      strengthText.text(getTranslationValue(config, [language, "password_strength_strong"], "Contraseña fuerte"));
      break;
  }  
});

// Evalúa fuerza de la contraseña
function evaluatePasswordStrength(password) {
  const lengthMet = password.length >= 6;
  const uppercaseMet = /[A-Z]/.test(password);
  const numberMet = /[0-9]/.test(password);
  const symbolMet = /[\W_]/.test(password);

  //Verifico que cumple con los requisitos mínimos obligatorios
  const minimumRequirementsMet = lengthMet && uppercaseMet && numberMet;

  let score;
  if (!minimumRequirementsMet) {
    //Si no cumple, clasificamos que tanto cumple
    score = 0;
    if (lengthMet && (uppercaseMet || numberMet)) score = 1; // medio (naranja)
  } else {
    score = symbolMet ? 3 : 2; // 2 = aceptable (amarillo), 3 = fuerte (verde)
  }

  return { score };
}

// Actualiza ítem con ícono Font Awesome
function updateRequirement($element, isValid, text) {
  const iconClass = isValid ? "fa-check-circle hint-purple" : "fa-times-circle text-muted";
  $element
    .html(`<i class="fas ${iconClass} mr-2"></i>${text}`)
    .removeClass("hint-purple text-muted")
    .addClass(isValid ? "hint-purple" : "text-muted");
}


$("#toggle-password").on("click", function () {
  const passwordInputs = [$("#user_password"), $("#user_password_confirmation")];
  const icon = $(this).find("i");

  const isHidden = passwordInputs[0].attr("type") === "password";

  passwordInputs.forEach(input => {
    input.attr("type", isHidden ? "text" : "password");
  });

  icon.toggleClass("fa-eye fa-eye-slash");
});